import React, { useState, useEffect } from "react";
import {
  Building2,
  Hash,
  Home,
  Truck,
  Coffee,
  Car,
  BedDouble,
  MapPin,
  CreditCard,
  CheckSquare,
} from "lucide-react";
import axios from "axios";
import Swal from "sweetalert2";

const ClientConfigModal = ({ show, onClose, client, baseUrl, config, Admin }) => {
   const AdminParse = JSON.parse(Admin)
  const [formData, setFormData] = useState({
    restaurantName: "",
    restaurantgst: "",
    takeaway: false,
    homeDelivery: false,
    dining: false,
    carOrder: false,
    roomOrder: false,
    restaurantAddress: "",
    restaurantPincode: "",
    posOrder: false,
    settlementAccount: "",
    settlementAccountifsc: "",
  });

  useEffect(() => {
    if (client) {
      setFormData((prev) => ({
        ...prev,
        restaurantName: client?.organization_name || "",
      }));
    }
  }, [client]);

  if (!client) return null;

  const handleSave = async () => {
    try {

      console.log(Admin.pkid);  
      const payload = {
        adminId: AdminParse.pkid,
        userid: client.us_code,
        restaurantgst: formData.restaurantgst,
        restaurantName: formData.restaurantName,
        takeaway: formData.takeaway ? "Y" : "N",
        homeDelivery: formData.homeDelivery ? "Y" : "N",
        restaurantAddress: formData.restaurantAddress,
        restaurantPincode: formData.restaurantPincode,
        dining: formData.dining ? "Y" : "N",
        carOrder: formData.carOrder ? "Y" : "N",
        roomOrder: formData.roomOrder ? "Y" : "N",
        posOrder: formData.posOrder ? "Y" : "N",
        settlementAccount: formData.settlementAccount,
        settlementAccountifsc: formData.settlementAccountifsc,
      };

      console.log("Sending payload:", payload);

      await axios.post(
        `${baseUrl}/api/Admin/v1.0/insertRestaurantOrderDetails`,
        payload,
        config
      );

      Swal.fire("Saved!", "Restaurant order details saved successfully.", "success");
      onClose();
    } catch (err) {
      console.error("insertRestaurantOrderDetails error:", err);
      Swal.fire("Error", "Unable to save restaurant details.", "error");
    }
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.45)" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
          {/* Header */}
          <div
            className="modal-header text-white"
            style={{ backgroundColor: "#01C37D" }}
          >
            <h5 className="modal-title d-flex align-items-center fw-bold">
              <Building2 className="me-2" size={22} />
              Configuration — {client.organization_name} ({client.us_code})
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body p-4">
            <div className="row g-4">
              {/* Restaurant Name */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  <Building2 size={16} className="me-1 text-success" /> Restaurant
                  Name
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  value={formData.restaurantName}
                  onChange={(e) =>
                    setFormData({ ...formData, restaurantName: e.target.value })
                  }
                />
              </div>

              {/* GST */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  <Hash size={16} className="me-1 text-success" /> GST Number
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  value={formData.restaurantgst}
                  onChange={(e) =>
                    setFormData({ ...formData, restaurantgst: e.target.value })
                  }
                />
              </div>

              {/* Functionalities */}
              <div className="col-12">
                <label className="form-label fw-semibold">
                  <CheckSquare size={16} className="me-1 text-success" />{" "}
                  Functionalities
                </label>
                <div className="d-flex flex-wrap gap-4">
                  {[
                    {
                      field: "homeDelivery",
                      label: "Home Delivery",
                      icon: <Truck size={16} className="me-1" />,
                    },
                    {
                      field: "takeaway",
                      label: "Take Away",
                      icon: <Coffee size={16} className="me-1" />,
                    },
                    {
                      field: "dining",
                      label: "Dining",
                      icon: <Home size={16} className="me-1" />,
                    },
                    {
                      field: "carOrder",
                      label: "Car Order",
                      icon: <Car size={16} className="me-1" />,
                    },
                    {
                      field: "roomOrder",
                      label: "Room Order",
                      icon: <BedDouble size={16} className="me-1" />,
                    },
                  ].map((opt) => (
                    <div className="form-check form-check-inline" key={opt.field}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={formData[opt.field]}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [opt.field]: e.target.checked,
                          })
                        }
                      />
                      <label className="form-check-label fw-medium">
                        {opt.icon} {opt.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              {/* Address (only if Home Delivery) */}
              {formData.homeDelivery && (
                <>
                  <div className="col-md-8">
                    <label className="form-label fw-semibold">
                      <MapPin size={16} className="me-1 text-success" /> Delivery
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={formData.restaurantAddress}
                      onChange={(e) =>
                        setFormData({ ...formData, restaurantAddress: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Pin Code</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={formData.restaurantPincode}
                      onChange={(e) =>
                        setFormData({ ...formData, restaurantPincode: e.target.value })
                      }
                    />
                  </div>
                </>
              )}

              {/* POS */}
              <div className="col-md-6">
                <div className="form-check mt-4">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={formData.posOrder}
                    onChange={(e) =>
                      setFormData({ ...formData, posOrder: e.target.checked })
                    }
                  />
                  <label className="form-check-label fw-semibold">
                    <CreditCard size={16} className="me-1 text-success" /> POS
                    Enabled
                  </label>
                </div>
              </div>

              {/* Settlement Account */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  <CreditCard size={16} className="me-1 text-success" /> Settlement
                  Account
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  value={formData.settlementAccount}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      settlementAccount: e.target.value,
                    })
                  }
                />
              </div>

              {/* Settlement IFSC */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  <CreditCard size={16} className="me-1 text-success" /> Settlement
                  IFSC
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  value={formData.settlementAccountifsc}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      settlementAccountifsc: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer bg-light">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-3 px-4"
              onClick={onClose}
            >
              Close
            </button>
            <button
              type="button"
              className="btn text-white rounded-3 px-4"
              style={{ backgroundColor: "#01C37D" }}
              onClick={handleSave}
            >
              Save Configuration
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientConfigModal;
